import { Navigate, useSearchParams } from "react-router-dom";
import { Users, ShieldCheck, UploadCloud, Building2, ScrollText, LayoutGrid, Contact } from "lucide-react";
import { AppShell } from "@/components/shell/AppShell";
import { useAuth } from "@/context/AuthContext";
import { UsersRolesPanel } from "@/pages/ManageUsersPage";
import { ClientsPanel, PermissionsPanel, UploadsPanel, ActivityLogPanel } from "@/pages/settings/panels";
import { ModulesPanel } from "@/pages/settings/ModulesPanel";
import { AgentMappingPanel } from "@/pages/settings/AgentMappingPanel";

const SECTIONS = [
  ["users", "Users & Roles", Users],
  ["permissions", "Permissions", ShieldCheck],
  ["activity", "Activity Logs", ScrollText],
  ["uploads", "Data Uploads", UploadCloud],
  ["agent-mapping", "Agent Mapping", Contact],
  ["modules", "Modules", LayoutGrid],
  ["clients", "Clients", Building2],
];

export default function SettingsPage() {
  const { user } = useAuth();
  const [params, setParams] = useSearchParams();
  const section = SECTIONS.some(([k]) => k === params.get("section")) ? params.get("section") : "users";
  if (!["admin", "super_admin"].includes(user?.role)) return <Navigate to="/" replace />;

  return (
    <AppShell>
      <div className="mk-fade mb-6">
        <h1 className="font-heading text-3xl font-extrabold tracking-tight text-thstrong sm:text-4xl">Settings <span className="ml-1 text-lg font-semibold text-thcyan">Workspace</span></h1>
        <p className="mk-label mt-2 tracking-[0.25em]">Users · Permissions · Logs · Monthly uploads · Agent mapping · Modules · Clients</p>
      </div>
      <div className="grid gap-6 lg:grid-cols-[220px_1fr]">
        <nav className="flex h-fit flex-row flex-wrap gap-1 lg:flex-col" data-testid="settings-subnav">
          {SECTIONS.map(([k, label, Icon]) => (
            <button key={k} data-testid={`settings-nav-${k}`} onClick={() => setParams({ section: k })}
              className={`flex items-center gap-2.5 rounded-xl px-4 py-2.5 text-left text-sm font-semibold transition-colors ${
                section === k ? "bg-thblue/15 text-thstrong" : "text-thmute hover:bg-thhover/5 hover:text-thstrong"}`}>
              <Icon className={`h-4 w-4 ${section === k ? "text-thcyan" : ""}`} /> {label}
            </button>
          ))}
        </nav>
        <div className="mk-fade min-w-0">
          {section === "users" && <UsersRolesPanel />}
          {section === "permissions" && <PermissionsPanel />}
          {section === "uploads" && <UploadsPanel />}
          {section === "agent-mapping" && <AgentMappingPanel />}
          {section === "modules" && <ModulesPanel />}
          {section === "clients" && <ClientsPanel />}
          {section === "activity" && <ActivityLogPanel />}
        </div>
      </div>
    </AppShell>
  );
}
